import React, { useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, DialogContentText, TextField} from "@material-ui/core"
import { printAssetCategory } from "../../../../entities/AssetCategory";
import { AssetCategoryType } from "../../../../entities/AssetType";
import { SaveLinkAssetRequest, LinkAssetService } from "../../../../services/LinkAssetService";
import { useLibrary, useLibraryAlert } from "../../LibraryPage";
import { FieldValidationError, ValidationHelper } from "../../../../services/server/ServerResponses";
import { convertLinkAssetToLibraryItem } from "../../../../entities/LinkAsset";

interface Props {
	open: boolean;
	selectedAssetType: AssetCategoryType;
	onClose: () => void;
	onSuccess: () => void;
}

export function AddNormalLinkDialog(props: Props) {
	const { open, selectedAssetType } = props;
	const context = useLibrary();
	const libraryAlert = useLibraryAlert();

	const [assetName, setAssetName] = useState("");
	const [addLinkUrl, setAddLinkUrl] = useState("");

	const [errors, setErrors] = useState<FieldValidationError[]>([]);
	const [disableActions, setDisableActions] = useState<boolean>(false);

	const onAddLinkUrl = async (e:React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const request: SaveLinkAssetRequest = {
			parentId: context.activeFolderId ?? undefined,
			name: assetName,
			isStarred: false,
			dateAccessed: new Date(),
			category: selectedAssetType.category,
			url: addLinkUrl,
			locationPreached: "",
			scripture: "",
		};

		setDisableActions(true);
		const response = await LinkAssetService.save(request);
		setDisableActions(false);

		if (response.validation) return setErrors(response.errors);
		if (response.error) return libraryAlert(response.message);

		const link = response.data;
		context.addLibraryItem(convertLinkAssetToLibraryItem(link));
		libraryAlert(`${link.name} created`, async () => {
			const result = await LinkAssetService.delete(link.id);
			if(result.success) {
				context.removeLibraryItem(link.id);
				libraryAlert(`Removed folder ${link.name}`);
			} else {
				libraryAlert(`Failed to delete folder ${link.name}`);
			}
		});
		props.onSuccess();
	};

	return (
		<Dialog open={open} onClose={props.onClose} onKeyDown={(e) => e.key === "Tab" ? e.stopPropagation() : undefined}>
			<DialogTitle id="form-dialog-title">{`New ${selectedAssetType.name}`}</DialogTitle>
			<form onSubmit={onAddLinkUrl}>
				<DialogContent>
					<DialogContentText>Enter the info of your new {printAssetCategory(selectedAssetType.category).toLowerCase()}.</DialogContentText>
					<TextField
						required
						autoFocus={true}
						margin="dense"
						id="newItemName"
						label="Name"
						type="text"
						onChange={(e) => setAssetName(e.currentTarget.value)}
						fullWidth
						error={ValidationHelper.isFieldInError(errors, "Name")}
						helperText={<span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(errors, "Name") }} />}
						/>
					<TextField
						required
						type="text"
						label="URL"
						placeholder="ex: https://www.yourlink.com"
						value={addLinkUrl}
						margin="dense"
						fullWidth
						onChange={(e) => setAddLinkUrl(e.target.value)}
						error={ValidationHelper.isFieldInError(errors, "Url")}
						helperText={<span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(errors, "Url") }} />}
						/>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.onClose} color="primary" disabled={disableActions}>
						Cancel
					</Button>
					<Button type="submit" color="primary" disabled={disableActions}>
						Add
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}